import { Box, Flex, Heading } from "@chakra-ui/react";
import { CarriersTable } from "../../components/carriers-table/carriers-table.comp";

export function CarrierList() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Carriers</Heading>
            </Flex>
            <CarriersTable />
        </Box>
    );
}
